import { useNavigate } from 'react-router';
import { usePalette, useTranslation } from 'src/hooks';
import { blobCreatorPageRoute } from 'src/routes/route-list';
import { Button, Typography } from 'src/components/atoms';
import { FlexColumn } from 'src/components/layout';

export const BlobsNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { primary } = usePalette();

  return (
    <FlexColumn textAlign='center' alignItems='center'>
      <Typography>{t('pages.mymes.editor.blobs.library.blobs_empty_text')}</Typography>
      <Button
        onClick={() => navigate(blobCreatorPageRoute)}
        color='primary'
        sx={{ mt: 2, backgroundColor: primary.main }}
      >
        {t('pages.mymes.editor.blobs.library.blobs_empty_btn')}
      </Button>
    </FlexColumn>
  );
};

export const FilteredBlobsNotFound = () => {
  const { t } = useTranslation();

  return (
    <FlexColumn textAlign='center' alignItems='center'>
      <Typography>{t('pages.mymes.editor.blobs.library.blobs_search_empty')}</Typography>
    </FlexColumn>
  );
};
